<style lang="scss" scoped>
img {
  min-width: 100%;
}

.hide-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 85%;
}
.icon {
  position: relative;
  bottom: 10px;
}

.avatar {
  display: block;
  position: relative;
  width: 100%;
  background-size: cover;

  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
}
</style>
<template>
  <div class="row">
    <div
      class="col-12 col-sm-4 col-md-3"
      v-for="(friend, index) in friends"
      :key="index"
    >
      <friends-info-box :profile="friend" class="pl-3 pb-3"></friends-info-box>
    </div>
    <div v-if="!hasFriends" class="col-12 text-center">
      Keine Freunde gefunden. Wenn Mitglieder deine Freundschaftsanfrage
      angenommen haben werden diese hier angezeigt.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      friends: {}
    };
  },
  mounted() {
    this.$http.get(`/api/v1/friends/`).then(response => {
      this.friends = response.data;
    });
  },
  methods: {
    primaryImageUrl(friend) {
      return (
        friend.primary_image.url +
        "?width=" +
        Laravel.settings.imagesize.memberSearchImages +
        "&height=" +
        Laravel.settings.imagesize.memberSearchImages
      );
    },
    profileUrl(friend) {
      return `/mitglied/${friend.name}`;
    }
  },
  computed: {
    displayErotic() {
      return Laravel.displayErotic;
    },
    displayNewMembers() {
      return Laravel.displayNewMembers;
    },
    displayNewMembersColor() {
      return Laravel.displayNewMembersColor;
    },
    hasFriends() {
      return this.friends !== null && this.friends.length > 0;
    },
    isOnline() {
      return this.$store.getters["online/profileOnline"](this.profile.id);
    }
  }
};
</script>
